import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function FindBooking() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const submit = (e) => {
    e.preventDefault();
    navigate(`/booking/${code.trim().toUpperCase()}?email=${encodeURIComponent(email.trim())}`);
  };
  return (
    <main className="mx-auto max-w-md px-5 py-24" data-testid="find-booking-page">
      <p className="eyebrow">My booking</p>
      <h1 className="mt-3 font-display text-4xl text-[#1F1B17]">Find your reservation</h1>
      <form onSubmit={submit} className="mt-10 space-y-5">
        <div><Label htmlFor="fb-code">Booking code</Label><Input id="fb-code" required placeholder="BK-XXXXXX" value={code} onChange={(e) => setCode(e.target.value)} className="mt-2 h-12 font-mono uppercase" data-testid="find-booking-code-input" /></div>
        <div><Label htmlFor="fb-email">Email used to book</Label><Input id="fb-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-12" data-testid="find-booking-email-input" /></div>
        <button type="submit" data-testid="find-booking-submit-button" className="w-full rounded bg-[#141210] py-4 text-sm font-semibold uppercase tracking-widest text-[#F3DDA4] hover:bg-[#2A2520]">Look it up</button>
      </form>
    </main>
  );
}
